var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 15.5H8.375H15.5V0.5H11.75V8.2475L8 5.75V8.2475L4.25 5.75V8.2475L0.5 5.75V15.5ZM4.76562 10.6375C4.76562 10.527 4.85517 10.4375 4.96562 10.4375H6.50147C6.61193 10.4375 6.70147 10.527 6.70147 10.6375V12.1682C6.70147 12.2787 6.61193 12.3682 6.50147 12.3682H4.96563C4.85517 12.3682 4.76562 12.2787 4.76562 12.1682V10.6375ZM9.07031 10.6375C9.07031 10.527 9.15985 10.4375 9.27031 10.4375H10.8062C10.9166 10.4375 11.0062 10.527 11.0062 10.6375V12.1682C11.0062 12.2787 10.9166 12.3682 10.8062 12.3682H9.27031C9.15986 12.3682 9.07031 12.2787 9.07031 12.1682V10.6375Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactory);
export default __webpack_public_path__ + "static/media/icon-factory.e1190c9c9359fbdedacda5cb2214d197.svg";
export { ForwardRef as ReactComponent };